import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import UserProfile from "../UserProfile/UserProfile";
import BackButton from "../Buttons/BackButton/BackButton";
import { ActiveUserContext, PanelSizeContext } from "../Dashboard/Dashboard";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

export default function UserProfileOverlay({
  handleUserUpdated
}) {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const [open, setOpen] = useState(true);
  const [selectedUser, setSelectedUser] = useState("");
  const [drawerWidth, setDrawerWidth] = useState("");
  const { sidebarWidth } = useContext(PanelSizeContext);
  const activeUser = useContext(ActiveUserContext);

  const handleDrawerClose = () => {
    setOpen(false);
    navigate(-1);
  };

  useEffect(() => {
    setSelectedUser(searchParams.get("user-id"));
  }, [activeUser]);

  useEffect(() => {
    setDrawerWidth(`calc(100vw - ${sidebarWidth}px - 2px)`);
  }, [sidebarWidth]);

  return (
    <Box sx={{ display: "flex" }}>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            height: "calc(100% - 130px)",
            top: 130,
          },
        }}
        variant="persistent"
        anchor="right"
        open={open}
      >
        <Box sx={{ padding: "0 30px 0 30px" }}>
          <DrawerHeader >
            <BackButton label={"Back to User Management"} onClick={handleDrawerClose} />
          </DrawerHeader>
          <UserProfile
            userId={selectedUser}
            handleUserUpdated={handleUserUpdated}
          />
        </Box>
      </Drawer>
    </Box>
  );
}

UserProfileOverlay.propTypes = {
  handleUserUpdated: PropTypes.func.isRequired
};